var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((_vm.restrictions),function(itemRes,index){return _c('li',{staticClass:"list-group-item",staticStyle:{"text-align":"justify"}},[_c('p',{staticClass:"p-0 m-0"},[_vm._v(_vm._s(itemRes))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }